/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Upsert configuration for client management
 * @export
 * @interface UpsertClientConfigurationPayload
 */
export interface UpsertClientConfigurationPayload {
	/**
	 * Enable or disable a pilot mode for client management
	 * @type {boolean}
	 * @memberof UpsertClientConfigurationPayload
	 */
	pilotMode?: boolean | null;
	/**
	 * User Id's for those who should be able to interact with Client Management in pilot mode.
	 * @type {Array<string>}
	 * @memberof UpsertClientConfigurationPayload
	 */
	pilotModeUserIds?: Array<string> | null;
}

/**
 * Check if a given object implements the UpsertClientConfigurationPayload interface.
 */
export function instanceOfUpsertClientConfigurationPayload(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function UpsertClientConfigurationPayloadFromJSON(
	json: any
): UpsertClientConfigurationPayload {
	return UpsertClientConfigurationPayloadFromJSONTyped(json, false);
}

export function UpsertClientConfigurationPayloadFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): UpsertClientConfigurationPayload {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		pilotMode: !exists(json, 'pilotMode') ? undefined : json['pilotMode'],
		pilotModeUserIds: !exists(json, 'pilotModeUserIds')
			? undefined
			: json['pilotModeUserIds'],
	};
}

export function UpsertClientConfigurationPayloadToJSON(
	value?: UpsertClientConfigurationPayload | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		pilotMode: value.pilotMode,
		pilotModeUserIds: value.pilotModeUserIds,
	};
}
